import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	useTheme
} from '@material-ui/core';

import Constants from "../utils/Constants";

const styles = makeStyles(theme => ({
	circle: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: "50%",
		border: "1px solid transparent",
		backgroundColor: theme.palette.primary.darkBlue
	}
}));

function AuditTrailIcon(props) {
	const theme = useTheme();

	let classes = styles(),
		{type, iconSize} = props,
		config = Constants.ACTIVITY.AUDIT_TRAIL[type.toUpperCase()];

	return config ? (
		<span
			className={classes.circle}
			style={{...{width: iconSize, height: iconSize}, ...config.ICON_STYLES}}>
			<FontAwesomeIcon
				title={config.ID}
				icon={["fas", config.ICON]}
				color={config.COLOR || theme.palette.common.white} />
		</span>
	) : null;
}

AuditTrailIcon.defaultProps = {
	iconSize: 36
};

AuditTrailIcon.propTypes = {
	type: PropTypes.string.isRequired,
	iconSize: PropTypes.number
};

export default AuditTrailIcon;